import React, { Fragment, useState } from 'react';
import T from 'prop-types';

import DeleteModal from '../../../../../components/DeleteModal';
import { toast } from '../../../../../components/Toasts';
import api from '../../../api';

const BulkDeleteModal = ({ open, selectedExports, onDeleteSuccess, onClose }) => {
  const [pending, setPending] = useState(false);

  const handleModalClose = () => {
    if (pending) return;
    onClose();
  };

  const handleExportDelete = () => {
    if (pending) return;

    setPending(true);

    api.customExports
      .deleteCustomExports({ custom_exports: selectedExports.map(({ id }) => ({ id })) })
      .then(() => {
        setPending(false);

        toast.success('Selected exports have been successfully deleted.');

        if (onDeleteSuccess) onDeleteSuccess();
        handleModalClose();
      })
      .catch(() => {
        setPending(false);

        toast.error('Oops! Something went wrong. Please, try again later');
      });
  };

  return (
    <DeleteModal
      open={open}
      buttonSize="lg"
      confirmButtonText="Delete Exports"
      confirmMessage={
        <Fragment>
          <span className="text-black">Delete Selected Exports?</span>
          <small>This cannot be undone</small>
        </Fragment>
      }
      closeButtonIconClass="hicon-close"
      loading={pending}
      onClose={handleModalClose}
      onDelete={handleExportDelete}
    />
  );
};

BulkDeleteModal.propTypes = {
  open: T.bool.isRequired,
  selectedExports: T.arrayOf(
    T.shape({
      id: T.number,
    })
  ).isRequired,
  onDeleteSuccess: T.func,
  onClose: T.func.isRequired,
};

export default BulkDeleteModal;
